// import {s360ConfigService} from "./Simplify360Chat/Services/S360Config";

import { s360ConfigService } from "./S360Config";
import HWUser from "../HWLibrary/HWUser";

const watchForChatSDKEvents = (appComponent, onDateRefresh) => {
  window.addEventListener('message',
    messageEvent => {
      console.log(messageEvent);
      if (!s360ConfigService.isClientHostConfigured() || messageEvent.origin !== s360ConfigService.sourceOrigin) return;
      console.log(messageEvent.data);

      try {
        let messageData = JSON.parse(messageEvent.data);
        if (!messageData || messageData.clientHostId !== s360ConfigService.clientHostId || !messageData.action) { return; }
        // console.log("Data: ");
        console.log(messageData);
        switch (messageData.action) {
          case "on-config-data-update": s360ConfigService.setConfig(messageData.data); break;
          case "on-reset-user":  onResetUser(onDateRefresh); break;
          case "on-set-user-config": s360ConfigService.setUserConfig(messageData.data); break;
          default: break;
        }
      } catch (error) { console.log("Invalid Message Data: "); }

      appComponent.setState({ refreshKey: new Date().toISOString() });
    },
    false
  );
};

const onResetUser = (onDateRefresh) => {
  HWUser.resetUser();
  onDateRefresh && onDateRefresh();
  window.location.reload();
}

const postPlatformMessage = (messageData, actionName) => {
 // if(!s360ConfigService.isClientHostConfigured() || !s360ConfigService.sourceOrigin) { return; }
  let message = { data: messageData, action: actionName , clientHostId: s360ConfigService.clientHostId };
  try { window.parent.postMessage(JSON.stringify(message), "*"); } catch (error) { console.log(error); }
};

const fetchConfigDetailsFromClientHost = () => {
  postPlatformMessage(null, 'update-client-host-config');
};

const sendOnAppOpen = () => {
  postPlatformMessage(null, 'on-app-open');
};

const sendOnAppClose = () => {
  postPlatformMessage(null, 'on-app-close');
};

export { watchForChatSDKEvents, fetchConfigDetailsFromClientHost, sendOnAppOpen, sendOnAppClose };
